import { Controller } from "@hotwired/stimulus"

// Select-and-tag pattern for multi-value fields.
// Wraps a Forms::SelectComponent — finds the <select> inside the controller element.
//
// data-tag-select-field-name-value="automation[stop_events][]"
// data-tag-select-selected-value='["leads.ingested"]'
export default class extends Controller {
  static targets = ["tags", "hiddens"]
  static values = { fieldName: String, selected: Array }

  connect() {
    this.selectEl = this.element.querySelector("select")
    this.render()
  }

  add() {
    const val = this.selectEl.value
    if (!val || this.selectedValue.includes(val)) {
      this.selectEl.value = ""
      return
    }
    this.selectedValue = [...this.selectedValue, val]
    this.selectEl.value = ""
    this.render()
  }

  remove(e) {
    const val = e.currentTarget.dataset.value
    this.selectedValue = this.selectedValue.filter(v => v !== val)
    this.render()
  }

  render() {
    this.tagsTarget.innerHTML = this.selectedValue.map(val => {
      const label = this.labelFor(val)
      return `<span class="inline-flex items-center gap-1 rounded-full bg-gray-100 dark:bg-gray-800 px-2.5 py-1 text-xs font-medium text-gray-700 dark:text-gray-300">
        ${this.escapeHtml(label)}
        <button type="button" data-action="tag-select#remove" data-value="${this.escapeAttr(val)}" class="ml-0.5 text-gray-400 hover:text-red-500 transition-colors">&times;</button>
      </span>`
    }).join("")

    this.hiddensTarget.innerHTML =
      `<input type="hidden" name="${this.fieldNameValue}" value="">` +
      this.selectedValue.map(val =>
        `<input type="hidden" name="${this.fieldNameValue}" value="${this.escapeAttr(val)}">`
      ).join("")
  }

  labelFor(val) {
    const option = this.selectEl.querySelector(`option[value="${CSS.escape(val)}"]`)
    return option ? option.textContent.trim() : val.replace(/\./g, " ")
  }

  escapeHtml(str) {
    const d = document.createElement("div")
    d.textContent = str
    return d.innerHTML
  }

  escapeAttr(str) {
    return str.replace(/"/g, "&quot;").replace(/'/g, "&#39;")
  }
}
